import { useT } from "@hooks";

interface Props {
  content: React.ReactNode;
  recurrenceId?: string | null;
  installmentNumber?: number | null;
  totalInstallments?: number | null;
}

const SharedCategoryCell = ({ content, recurrenceId, installmentNumber, totalInstallments }: Props) => {
  const t = useT();
  const hasPosition = !!installmentNumber && !!totalInstallments;

  return (
    <span>
      <span>{content}</span>
      {recurrenceId && (
        <span
          className="badge bg-white text-color-primary border border-color-primary margin-left-10"
          data-testid="recurrence-position-badge"
        >
          {hasPosition
            ? t("batchDelete.recurrenceBadge.position", { current: installmentNumber, total: totalInstallments })
            : t("batchDelete.recurrenceBadge.unknown")}
        </span>
      )}
    </span>
  );
};

export default SharedCategoryCell;
